var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGeofence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.534,
    height: 19.582,
    viewBox: "0 0 18.534 19.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M19.294,17.724l-1.338-4.016H16.487l.816,3.916H2.943l.816-3.916H2.29L.951,17.724a1.329,1.329,0,0,0,1.34,1.858H17.956A1.328,1.328,0,0,0,19.294,17.724ZM15.019,4.9a4.9,4.9,0,0,0-9.791,0c0,4.675,4.9,9.791,4.9,9.791S15.019,9.571,15.019,4.9ZM7.48,4.954A2.644,2.644,0,1,1,10.123,7.6,2.642,2.642,0,0,1,7.48,4.954Z",
    transform: "translate(-0.856)",
    fill: "#4a4a4a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeofence);
export default __webpack_public_path__ + "static/media/Icon_Geofence.36e21c77.svg";
export { ForwardRef as ReactComponent };